import { Flex } from 'lib/ui';
import { ThemeUIStyleObject } from 'theme-ui';
import { ReactNode } from 'react';
import { CustomFlexProps } from './Flex';

interface GridCellProps extends CustomFlexProps {
  children?: ReactNode
  sx?: ThemeUIStyleObject
  header?: boolean
}

export default function GridCell({ children, sx = {}, header, ...props }: GridCellProps) {
  return (
    <Flex
      sx={{
        backgroundColor: header ? '#ddd' : '#fff',
        padding: 1,
        minHeight: '26px',
        ...sx
      }}
      {...props}
    >
      {children}
    </Flex>
  );
}
